module.exports = __webpack_public_path__ + "static/media/CitizenIconEmpty.493c0a9d.png";